/** ==================================================
 * ポップアップバナーに関する処理
 * ポップアップにはIDを付与し、一度ポップアップが閉じられたら同じIDを持つポップアップは再び表示されることがないようにする。
 * 閉じられたことはIDと紐付けてlocalStorageに書き込む。ポップアップを開くタイミングでlocalStorageを確認し、閉じられた履歴がなければポップアップを表示する。
 *
 * API:
 * @see showPopup()
 * @see closePopup()
 * @see isRegistrationCookie(string)
  ==================================================*/

/**
 * イベントリスナの登録
 * load時にポップアップの表示処理を行う
 */
window.addEventListener('load', showPopup, false);

/**
 * ポップアップを表示する
 * ポップアップは一度閉じられたら再度開くことはないため、閉じた時はlocalStorageにIDと紐付けて書き込んでいる。
 * そのため開く前にlocalStorageの記録をチェックし、過去閉じられた記録がなければポップアップを表示する。
 * また、ポップアップが表示されているときに背後の要素がスクロールされないようにスクロール禁止の処理も行っている。
 * @see modalControl.js#scrollFix(HTMLElement)
 */
function showPopup() {
  const popupId = document.getElementById('js-popup').dataset.id;

  // 同じIDを持つポップアップが過去に閉じられた記録がなければポップアップを開く
  if (!isRegistrationCookie(popupId)) {
    setTimeout(() => {
      const popup = document.getElementById('js-popup');
      popup.setAttribute('aria-hidden', false);

      // モーダル表示用のクラスを追加
      // modalが出たタイミングでスクロールを禁止 クラスの追加でbodyに「overflow: hidden」がつくようにスタイルを当てておく 
      document.documentElement.classList.add('_scrollLock');

      // キーボードフォーカスの制御イベントを登録
      window.addEventListener('keydown', focusHandleMenu, { capture: true });

      // スクロール固定のイベントを登録
      document.addEventListener('touchmove', scrollLock, { passive: false });
      scrollLockFix(popup);
    }, 600);
  }

    //モーダルの閉じるボタンの位置を調整しながら表示
    // adjustCloseButtonPosition()
    // 画面サイズが変更された際に閉じるボタンの位置を調整する
    // window.addEventListener('resize', adjustCloseButtonPosition);
    // 初期表示時にも位置調整を行う
    // window.addEventListener('load', adjustCloseButtonPosition);
    
    function adjustCloseButtonPosition(){
    //domが読み込まれたら登録されている要素の横幅を取得してCSSを追記する
    const popupBanner = document.querySelector('.popup__banner picture img');

    // getBoundingClientRectを使用して要素の位置を取得
    const rect = popupBanner.getBoundingClientRect();
    //右上隅の座標を取得
    const left = rect.right + window.scrollX - 20;
    const top = rect.top + window.scrollY;

    const popupCloseBtn = document.querySelector('.popup__content button');

    popupCloseBtn.style.left = left + 'px';

    }
}

/**
 * ポップアップを閉じる処理
 * ポップアップを開くときに行ったスクロール禁止処理の解除とcookieへの書き込みを行う
 * ポップアップが閉じられたことはcookieにID付きで書き込む
 * @param {string} id ポップアップの識別ID
 * @see modalControl.js#scrollFixRemove(HTMLElement)
 */
function closePopup(id) {
  const popup = document.getElementById('js-popup');
  popup.setAttribute('aria-hidden', true);

  //modalが閉じられた段階でスクロールできるように解除
  document.documentElement.classList.remove('_scrollLock');
  // Open時にbodyに追加したクラスを削除
  // クラスの削除で「overflow: hidden」が外れる。
  document.body.classList.remove('_scrollLock');
  // キーボードフォーカスの制御を破棄
  window.removeEventListener('keydown', focusHandleMenu, { capture: true });
  // スクロール固定のイベントを破棄
//   document.removeEventListener('touchmove', scrollLock);
//   scrollLockFixRemove(popup);
  // ⭐フォーカス位置を戻す
  document.body.focus();
  // localStorageにポップアップが閉じられたことを保存する
  localStorage.setItem(`popup-${id}`, 'close');
}

/**
 * ポップアップが閉じられた記録がlocalStorageに保存されているかを判定する
 * ポップアップが過去に閉じられていたらtrueを返す
 * @param {string} id popupの識別ID
 * @returns {boolean} localStorageに閉じられた履歴が残っていればtrue
 */
function isRegistrationCookie(id) {
  // localStorageに渡されたIDのポップアップが閉じられた記録があるか確認する　
  const value = localStorage.getItem(`popup-${id}`);

  return value === 'close' ? true : false;
}

// キーボードフォーカスのイベントハンドラ
const focusHandleMenu = event => {
  modalFocus(event, document.getElementById('js-popup'), close);
}